import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getSystems(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "E-shop",
			iconName: brackets,
			href: getEcommercePath(tenant),
			show: true,
		},
		{
			title: "Webové aplikace",
			iconName: brackets,

			href: getWebAppsPath(tenant),
			show: true,
		},
		{
			title: "ERP systémy",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "CRM systémy",
			iconName: brackets,
			href: getCrmPath(tenant),
			show: true,
		},
		{
			title: "Účetní systémy",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Externí systémy",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Projektové nástroje",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Platební brány",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Analytické a reportovací nástroje",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Databázové systémy",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Docházkové systémy",
			iconName: brackets,
			href: "#",
			show: false,
		},
		{
			title: "Helpdesk a zákaznická podpora",
			iconName: brackets,
			href: "#",
			show: false,
		},
	];
}
